import apiClient from '../../helpers/apiClient'
import {handleApiError} from '../../utils/handleApiError'
import {PromoBanner, PromoBannerFormValues} from './types'

const BASE = '/banners/'

export async function listPromoBanners(): Promise<PromoBanner[]> {
  try {
    const response = await apiClient.get(BASE)
    const data = response.data
    return Array.isArray(data) ? data : data?.results ?? []
  } catch (error) {
    // Silencioso: los banners son opcionales, si el endpoint falla no debe
    // interrumpir el UX de /main-dashboard con un modal genérico.
    return []
  }
}

function toFormData(values: PromoBannerFormValues): FormData {
  const fd = new FormData()
  if (values.image instanceof File) {
    fd.append('image', values.image)
  }
  fd.append('link', values.link)
  fd.append('alt_text', values.alt_text)
  fd.append('style', values.style)
  fd.append('position', String(values.position))
  fd.append('is_active', values.is_active ? 'true' : 'false')
  return fd
}

export async function createPromoBanner(values: PromoBannerFormValues): Promise<PromoBanner | null> {
  try {
    const response = await apiClient.post(BASE, toFormData(values), {
      headers: {'Content-Type': 'multipart/form-data'},
    })
    return response.data
  } catch (error) {
    handleApiError(error, {})
    return null
  }
}

export async function updatePromoBanner(
  id: number,
  values: PromoBannerFormValues
): Promise<PromoBanner | null> {
  try {
    const response = await apiClient.patch(`${BASE}${id}/`, toFormData(values), {
      headers: {'Content-Type': 'multipart/form-data'},
    })
    return response.data
  } catch (error) {
    handleApiError(error, {})
    return null
  }
}

export async function deletePromoBanner(id: number): Promise<boolean> {
  try {
    await apiClient.delete(`${BASE}${id}/`)
    return true
  } catch (error) {
    handleApiError(error, {})
    return false
  }
}
